// extracted by mini-css-extract-plugin
export default {"step4":"Step4_step4__8km9k","heading":"Step4_heading__RwUCE","buttons":"Step4_buttons__4XA3h"};